import { NgModule, LOCALE_ID } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import localeEn from '@angular/common/locales/en'
import { registerLocaleData } from '@angular/common';
registerLocaleData(localeEn, 'en');

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { configureSp } from './auth';
import { HeaderComponent } from './header/header.component';
import { HomeComponent } from './home/home.component';
import { SignedOutComponent } from './signed-out/signed-out.component';
import { ChannelNavigatorComponent } from './channel-navigator/channel-navigator.component';
import { ToastrModule } from 'ngx-toastr';

import { NgbDateParserFormatter, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { SearchComponent } from './search/search.component';
import { SideBarService } from './services/side-bar.service';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule } from '@angular/forms';
import { DocumentsListModule } from './common/documents-list/documents-list.module';
import { HttpClientModule } from '@angular/common/http';
import { LayoutComponent } from './layout/layout.component';
import { LoginComponent } from './login/login.component';
import { AccessRequestComponent } from './access-request/access-request.component';
import { AccessRequestAlreadyComponent } from './access-request-already/access-already.component';
import { AccessRequestSubmmittedComponent } from './access-request-submitted/access-submitted.component';
import { AccountComponent } from './account/account.component';
import { FooterComponent } from './footer/footer.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { ConfirmationDialogComponent } from './common/confirmation-dialog/confirmation-dialog.component';
import { ConfirmationDialogService } from './common/confirmation-dialog/confirmation-dialog.service';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';
import { DatePipe } from '@angular/common';
import { SpSearchComponent } from './sp-search/sp-search.component';
import { NgxSliderModule } from '@angular-slider/ngx-slider';
import { NgbDateCustomParserFormatter } from './services/custom-date-formatter.service';
import { DocIconModule } from './common/doc-icon/doc-icon.module';
import { SpSearchResultsComponent } from './sp-search/sp-search-results/sp-search-results.component';
import { ListFilterModule } from './common/list-filter/list-filter.module';
import { SearchItemTitleComponent } from './sp-search/search-item-title/search-item-title.component';
import { SignoutComponent } from './signout/signout.component';
import { SimpleTextInputDialogService } from './common/simple-text-input-dialog/simple-text-input-dialog.service';
import { ReloadComponent } from './reload/reload.component';
import { ErrorComponent } from './error/error.component';
import { HighlightModule } from './lib/highlight/highlight.module';


configureSp();

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    HomeComponent,
    SignedOutComponent,
    ChannelNavigatorComponent,
    SearchComponent,
    LayoutComponent,
    LoginComponent,
    AccessRequestComponent,
    AccessRequestSubmmittedComponent,
    AccessRequestAlreadyComponent,
    AccountComponent,
    FooterComponent,
    ConfirmationDialogComponent,
    SpSearchComponent,
    SpSearchResultsComponent,
    SearchItemTitleComponent,
    SignoutComponent,
    ReloadComponent,
    ErrorComponent
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    BrowserAnimationsModule,
    FormsModule,
    NgbModule,
    AppRoutingModule,
    ToastrModule.forRoot({
      timeOut: 10000,
      preventDuplicates: true,
      positionClass: 'toast-top-left',
      closeButton: true
    }),
    DocumentsListModule,
    NgSelectModule,
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: environment.production,
      // Register the ServiceWorker as soon as the app is stable
      // or after 30 seconds (whichever comes first).
      registrationStrategy: 'registerWhenStable:30000'
    }),
    NgxSliderModule,
    DocIconModule,
    ListFilterModule,
    HighlightModule
  ],
  providers: [
    SideBarService,
    ConfirmationDialogService,
    SimpleTextInputDialogService,
    DatePipe,
    {provide: LOCALE_ID, useValue: 'en'},
    { provide: NgbDateParserFormatter, useClass: NgbDateCustomParserFormatter },
    {provide: 'googleTagManagerId', useValue: 'GTM-TZS8WBC'} //  GTM-TD2RBXX
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
